import { render, staticRenderFns } from "./PermissionsEdit.vue?vue&type=template&id=702f629e&"
import script from "./PermissionsEdit.vue?vue&type=script&lang=ts&"
export * from "./PermissionsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports